import toastr from 'toastr/build/toastr.min';

export class Toastr {
    static success(message) {
        return toastr.success(message, 'Success', defaultOptions);
    }

    static error(message, options = {}) {
        return toastr.error(message, 'Error', {
            ...defaultOptions,
            ...options
        });
    }

    static warning(message) {
        return toastr.warning(message, 'Warning', defaultOptions);
    }

    static info(message) {
        return toastr.info(message, 'Info', defaultOptions);
    }
}

let defaultOptions = {
    closeButton: true,
    debug: false,
    newestOnTop: true,
    progressBar: true,
    positionClass: 'toast-top-right',
    preventDuplicates: true,
    onclick: null,
    showDuration: 300,
    hideDuration: 1000,
    timeOut: 10000,
    extendedTimeOut: 1000,
    showEasing: 'swing',
    hideEasing: 'linear',
    showMethod: 'fadeIn',
    hideMethod: 'fadeOut'
};



// WEBPACK FOOTER //
// ./src/components/Toastr/index.js